import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ADMIN_API_ENDPOINTS } from "service/apiUrl";
import { API } from "service/Interceptor";

const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth();

const fromDate = new Date(currentYear, currentMonth, 1);
const toDate = new Date(currentYear, currentMonth + 1, 0);

const initialState = {
  grossVolume: null,
  signUpUsers: null,
  metrics: null,
  usersByIndustry: null,
  usersByPreference: null,
  membership: null,
  onlinePresence: { count: 0, users: [] },
  isLoading: false,
  // filters: {
  //   fromDate: new Date(`${currentYear}-${currentMonth + 1}-01`).toISOString(),
  //   toDate: new Date(`${currentYear}-${currentMonth + 1}-31`).toISOString(),
  // },
  filters: {
    fromDate: fromDate.toISOString(),
    toDate: toDate.toISOString(),
  },
};

export const getGrossVolume = createAsyncThunk(
  "get-gross-volume",
  async ({ filters }) => {
    try {
      const queryParams = new URLSearchParams();
      if (filters?.fromDate) queryParams.append("fromDate", filters.fromDate);
      if (filters?.toDate) queryParams.append("toDate", filters.toDate);
      const res = await API.get(
        `${ADMIN_API_ENDPOINTS.GROSS_VOLUME}?${queryParams.toString()}`,
      );
      return res?.data?.data;
    } catch (error) {
      console.log("error", error);
    }
  },
);
export const getSignUpCounts = createAsyncThunk(
  "get-signup-count",
  async ({ filters }) => {
    try {
      const queryParams = new URLSearchParams();
      if (filters?.fromDate) queryParams.append("fromDate", filters.fromDate);
      if (filters?.toDate) queryParams.append("toDate", filters.toDate);
      const res = await API.get(
        `${ADMIN_API_ENDPOINTS.SIGNUP_COUNT}?${queryParams.toString()}`,
      );
      return res?.data?.data;
    } catch (error) {
      console.log("error", error);
    }
  },
);

export const getMetrics = createAsyncThunk(
  "get-metrics",
  async ({ filters }) => {
    try {
      const queryParams = new URLSearchParams();
      if (filters?.fromDate) queryParams.append("fromDate", filters.fromDate);
      if (filters?.toDate) queryParams.append("toDate", filters.toDate);
      const res = await API.get(
        `${ADMIN_API_ENDPOINTS.METRICS}?${queryParams.toString()}`,
      );
      return res?.data?.data;
    } catch (error) {
      console.log("error", error);
    }
  },
);

export const getUsersByIndustry = createAsyncThunk(
  "get-users-by-industry",
  async ({ filters }) => {
    try {
      const queryParams = new URLSearchParams();
      if (filters?.fromDate) queryParams.append("fromDate", filters.fromDate);
      if (filters?.toDate) queryParams.append("toDate", filters.toDate);
      const res = await API.get(
        `${ADMIN_API_ENDPOINTS.USERS_BY_INDUSTRY}?${queryParams.toString()}`,
      );
      return res?.data?.data;
    } catch (error) {
      console.log("error", error);
    }
  },
);

export const getUsersByPreference = createAsyncThunk(
  "get-users-by-preference",
  async ({ filters }) => {
    try {
      const queryParams = new URLSearchParams();
      if (filters?.fromDate) queryParams.append("fromDate", filters.fromDate);
      if (filters?.toDate) queryParams.append("toDate", filters.toDate);
      const res = await API.get(
        `${ADMIN_API_ENDPOINTS.USERS_BY_PREFERENCE}?${queryParams.toString()}`,
      );
      return res?.data?.data;
    } catch (error) {
      console.log("error", error);
    }
  },
);

export const getOnlinePresence = createAsyncThunk(
  "get-online-presence",
  async () => {
    try {
      const res = await API.get(ADMIN_API_ENDPOINTS.ONLINE);
      return res?.data?.data;
    } catch (error) {
      console.log("error", error);
    }
  },
);

export const getMembership = createAsyncThunk(
  "get-membership",
  async ({ filters }) => {
    try {
      const queryParams = new URLSearchParams();
      if (filters?.fromDate) queryParams.append("fromDate", filters.fromDate);
      if (filters?.toDate) queryParams.append("toDate", filters.toDate);
      const res = await API.get(
        `${ADMIN_API_ENDPOINTS.MEMBERSHIP}?${queryParams.toString()}`,
      );
      return res?.data?.data;
    } catch (error) {
      console.log("error", error);
    }
  },
);

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      //--------------GROSS VOLUME--------------------
      .addCase(getGrossVolume.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getGrossVolume.fulfilled, (state, action) => {
        state.isLoading = false;
        state.grossVolume = action.payload;
      })
      .addCase(getGrossVolume.rejected, (state, action) => {
        state.isLoading = false;
      })
      //-------------METRICS--------------------
      .addCase(getMetrics.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getMetrics.fulfilled, (state, action) => {
        state.isLoading = false;
        state.metrics = action.payload;
      })
      .addCase(getMetrics.rejected, (state, action) => {
        state.isLoading = false;
      })
      //----------USERS BY INDUSTRY-----------------------
      .addCase(getUsersByIndustry.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getUsersByIndustry.fulfilled, (state, action) => {
        state.isLoading = false;
        state.usersByIndustry = action.payload;
      })
      .addCase(getUsersByIndustry.rejected, (state, action) => {
        state.isLoading = false;
      })
      //----------USERS BY PREFERENCE-----------------------
      .addCase(getUsersByPreference.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getUsersByPreference.fulfilled, (state, action) => {
        state.isLoading = false;
        state.usersByPreference = action.payload;
      })
      .addCase(getUsersByPreference.rejected, (state, action) => {
        state.isLoading = false;
      })
      //----------------MEMBERSHIP--------------------------
      .addCase(getMembership.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getMembership.fulfilled, (state, action) => {
        state.isLoading = false;
        state.membership = action.payload;
      })
      .addCase(getMembership.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(getSignUpCounts.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getSignUpCounts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.signUpUsers = action.payload;
      })
      .addCase(getSignUpCounts.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(getOnlinePresence.fulfilled, (state, action) => {
        if (action.payload) {
          state.onlinePresence = action.payload;
        }
      });
  },
});

export const { setFilters } = dashboardSlice.actions;
export default dashboardSlice.reducer;
